import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div>Vladimir Alferov</div>
                <div><a className="footer-href" href="tel:+79634694656"> tel number: +7 (963) 469-46-56 </a></div>
                <div><a className="footer-href" href="mailto:vladim.alferov@gmail.com"> email: vladim.alferov@gmail.com</a></div>
                <div><a className="footer-href" target="blank" href="https://www.linkedin.com/in/vladimir-alferov-01991516b/" >linkedin</a></div>
            </div>
        )
    }
}
